<template>
  <aside
    class="cw-sidebar w-[248px] shrink-0 border-r border-white/[0.08] bg-[#0c0c0e] flex flex-col text-[11px] min-h-0"
  >
    <div class="cw-sidebar__brand px-3 pt-3 pb-3 border-b border-white/[0.06]">
      <button type="button" class="cw-sidebar__back" title="返回首页" @click="onBack">
        <span class="cw-sidebar__back-icon" aria-hidden="true">
          <i class="fas fa-chevron-left"></i>
        </span>
        <span>返回</span>
      </button>
    </div>

    <div class="p-3 border-b border-white/[0.06]">
      <button
        type="button"
        class="cw-sidebar__new-btn w-full h-9 rounded-lg text-xs font-semibold tracking-wide text-white"
        @click="$emit('new-project')"
      >
        <i class="fas fa-plus mr-1.5 text-[10px] opacity-90"></i>
        新建项目
      </button>
    </div>

    <div
      class="shrink-0 px-3 py-2 flex items-center justify-between border-b border-white/[0.06] bg-[#0a0a0c]/80"
    >
      <span class="text-[10px] text-gray-500 font-medium uppercase tracking-wider">历史项目</span>
      <button
        type="button"
        class="h-7 w-7 rounded-lg text-gray-500 hover:text-gray-200 hover:bg-white/[0.06] flex items-center justify-center disabled:opacity-40"
        title="刷新列表"
        :disabled="loading"
        @click="$emit('refresh')"
      >
        <i class="fas fa-sync-alt text-[11px]" :class="{ 'fa-spin': loading }"></i>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto overflow-x-hidden p-2 space-y-1.5 min-h-0 scrollbar-thin">
      <p v-if="error" class="text-amber-200/90 px-1 text-[10px] leading-relaxed">{{ error }}</p>
      <p v-if="loading && !items.length" class="px-2 py-8 text-center text-[10px] text-gray-500">
        加载中…
      </p>
      <p
        v-else-if="!error && !items.length"
        class="px-2 py-8 text-center text-[10px] text-gray-600 leading-relaxed"
      >
        暂无历史记录<br />
        <span class="text-gray-500">发送消息后将自动保存</span>
      </p>
      <button
        v-for="p in items"
        :key="p.uuid"
        type="button"
        class="w-full text-left rounded-xl border transition-colors flex gap-2.5 p-2 items-start"
        :class="
          p.uuid === activeUuid
            ? 'cw-sidebar__session--active'
            : 'border-white/[0.06] bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/10'
        "
        :title="p.title"
        @click="$emit('open-session', p)"
      >
        <div
          class="w-11 h-11 rounded-lg shrink-0 overflow-hidden border border-white/[0.08] bg-[#141418] flex items-center justify-center"
        >
          <img
            v-if="p.thumb"
            :src="p.thumb"
            alt=""
            class="w-full h-full object-cover"
            loading="lazy"
            @error="onThumbError($event)"
          />
          <i v-else class="far fa-comments text-gray-600 text-sm"></i>
        </div>
        <div class="min-w-0 flex-1 pt-0.5">
          <p
            class="text-[11px] font-medium truncate leading-tight"
            :class="p.uuid === activeUuid ? 'text-white' : 'text-gray-300'"
          >
            {{ p.title || '未命名' }}
          </p>
          <p v-if="p.time" class="text-[9px] text-gray-500 mt-1 tabular-nums">{{ p.time }}</p>
        </div>
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ConversationWorkflowSidebar',
  props: {
    items: { type: Array, default: () => [] },
    activeUuid: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' }
  },
  methods: {
    onBack() {
      this.$router.push('/').catch(() => {})
    },
    onThumbError(e) {
      const el = e && e.target
      if (el) el.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.cw-sidebar__back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 12px 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.055);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}
.cw-sidebar__back:hover {
  background: rgba(255, 255, 255, 0.09);
  border-color: rgba(255, 255, 255, 0.16);
  color: #fff;
}
.cw-sidebar__back-icon {
  display: inline-flex;
  width: 16px;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  opacity: 0.9;
}

.cw-sidebar__new-btn {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(152deg, #2a2838 0%, #1e1c28 52%, #181622 100%);
  color: rgba(228, 226, 240, 0.95);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 8px 24px -12px rgba(0, 0, 0, 0.55);
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    color 0.18s ease;
}
.cw-sidebar__new-btn:hover {
  border-color: rgba(255, 255, 255, 0.16);
  background: linear-gradient(152deg, #343244 0%, #262432 52%, #1e1c28 100%);
  color: #fff;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 14px rgba(129, 140, 248, 0.1);
}
.cw-sidebar__session--active {
  border-color: rgba(129, 140, 248, 0.32);
  background: rgba(99, 102, 241, 0.08);
  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.12);
}
</style>
